import * as React from "react";
import Popover from "@mui/material/Popover";
import { makeStyles } from "@material-ui/core/styles";
import IconCheck from "@material-ui/icons/Check";
import Typography from "@mui/material/Typography";
import { Close, KeyboardArrowUp, KeyboardArrowDown } from "@material-ui/icons";

export default function TripType(props) {
  const tripOptions = { "One Way": "One Way", Return: "Two Way" };

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleUpdate = (val) => {
    if (props.onChange) props.onChange(val);
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  let tripIcon = <></>;
  let tripType = props.value;

  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      <div className="action-button" onClick={handleClick}>
        <Typography component="span" className="clipped-label">
          {" "}
          {tripOptions[props.value]}
        </Typography>
        <Typography component="span" style={{ marginLeft: 10 }}>
          {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
        </Typography>
      </div>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <div
          style={{
            width: "200px",
            // backgroundColor: "var(--backgroundcolor)",
            borderRadius: "5px",
            padding: "8px",
          }}
        >
          {Object.keys(tripOptions).map((item) => (
            <div
              className={`select-option ${item == tripType ? "active" : ""}`}
              onClick={() => handleUpdate(item)}
            >
              {/* {" "}
              {item == tripType ? (
                <IconCheck style={{ fontSize: 15 }} />
              ) : (
                <>&nbsp;&nbsp;&nbsp;</>
              )}{" "} */}
              <Typography
                component="span"
                style={{ color: "var(--textdarker)" }}
              >
                {" "}
                {tripOptions[item]}
              </Typography>
            </div>
          ))}
        </div>
      </Popover>
    </div>
  );
}

TripType.defaultProps = {
  value: "",
};

const roundTrip = (
  <span class="VfPpkd-kBDsod" aria-hidden="true">
    <svg
      enable-background="new 0 0 24 24"
      height="20"
      viewBox="0 0 24 24"
      fill="var(--darker)"
      width="20"
      focusable="false"
      class=" NMm5M hhikbc"
    >
      <g>
        <rect fill="none" height="24" width="24" x="0"></rect>
      </g>
      <g>
        <g>
          <polygon points="8.41,12.41 7,11 2,16 7,21 8.41,19.59 5.83,17 21,17 21,15 5.83,15"></polygon>
          <polygon points="15.59,11.59 17,13 22,8 17,3 15.59,4.41 18.17,7 3,7 3,9 18.17,9"></polygon>
        </g>
      </g>
    </svg>
  </span>
);

const oneWay = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    focusable="false"
    class=" NMm5M hhikbc"
    fill="var(--darker)"
  >
    <path d="M16.79 7.79l-1.41 1.42L17.17 11H3v2h14.17l-1.79 1.79 1.41 1.42L21 12z"></path>
  </svg>
);

const multiCity = (
  <svg
    fill="var(--darker)"
    enable-background="new 0 0 24 24"
    height="20"
    viewBox="0 0 24 24"
    width="20"
    focusable="false"
    class=" NMm5M hhikbc"
  >
    <g>
      <path d="M11,8c0,0.55-0.45,1-1,1S9,8.55,9,8s0.45-1,1-1S11,7.45,11,8z M6,7C5.45,7,5,7.45,5,8s0.45,1,1,1s1-0.45,1-1S6.55,7,6,7z M14,17c0.55,0,1-0.45,1-1c0-0.55-0.45-1-1-1s-1,0.45-1,1C13,16.55,13.45,17,14,17z M15.59,5.41L17.17,7L13,7v2l4.17,0l-1.59,1.59 L17,12l4-4l-4-4L15.59,5.41z M8.41,18.59L6.83,17L11,17v-2l-4.17,0l1.59-1.59L7,12l-4,4l4,4L8.41,18.59z M18,17c0.55,0,1-0.45,1-1 c0-0.55-0.45-1-1-1s-1,0.45-1,1C17,16.55,17.45,17,18,17z"></path>
      <rect fill="none" height="24" width="24"></rect>
    </g>
  </svg>
);
